import pickBy from 'lodash/pickBy';

/**
 * Cleanup params object by removing keys for null and undefined values.
 */
export const cleanParams = (params: Record<string, any>) => {
    return pickBy(params, (value) => value !== null && value !== undefined);
};
